export enum SpinnerSize {
  Small = "w-4 h-4",
  Medium = "w-8 h-8",
  Large = "w-16 h-16",
}